import { Link } from 'react-router-dom';
import { useT } from '../../../../i18n/I18nProvider';
import { PageHeading } from '../../../../ui/atoms/PageHeading';
import { PublicShell } from '../../layouts/PublicShell';

export function NotFoundPage() {
  const { t } = useT();

  return (
    <PublicShell>
      <div className="card bg-base-100 shadow-xl w-full max-w-md">
        <div className="card-body items-center text-center gap-4">
          <PageHeading className="card-title">
            {t('public.notFound:title')}
          </PageHeading>
          <p>{t('public.notFound:message')}</p>
          <Link to="/" className="btn btn-neutral">
            {t('public.notFound:home')}
          </Link>
        </div>
      </div>
    </PublicShell>
  );
}
